function initCarouselNav(root = document) {
  root.querySelectorAll('[data-carousel-nav-target]').forEach((scrollTarget) => {
    if (scrollTarget.dataset.carouselNavBound === 'true') return;
    scrollTarget.dataset.carouselNavBound = 'true';

    const wrapper = scrollTarget.closest('[data-carousel-nav]');
    if (!wrapper) return;

    const prevButton = wrapper.querySelector('[data-carousel-nav-arrow="prev"]');
    const nextButton = wrapper.querySelector('[data-carousel-nav-arrow="next"]');

    const updateScrollButtons = () => {
      const maxScroll = scrollTarget.scrollWidth - scrollTarget.clientWidth;
      const scrollLeft = scrollTarget.scrollLeft;
      const atStart = scrollLeft < 4;
      const atEnd = maxScroll < 4 || scrollLeft > maxScroll - 4;

      if (prevButton) {
        prevButton.toggleAttribute('hidden', atStart);
        prevButton.disabled = atStart;
      }
      if (nextButton) {
        nextButton.toggleAttribute('hidden', atEnd);
        nextButton.disabled = atEnd;
      }
    };

    wrapper.querySelectorAll('[data-carousel-nav-arrow]').forEach((arrow) => {
      let handledByTouch = false;

      const scroll = () => {
        if (arrow.disabled) return;
        const direction = arrow.dataset.carouselNavArrow === 'prev' ? -1 : 1;
        scrollTarget.scrollBy({ left: direction * 260, behavior: 'smooth' });
      };

      arrow.addEventListener('click', () => {
        if (handledByTouch) {
          handledByTouch = false;
          return;
        }
        scroll();
      });

      arrow.addEventListener(
        'touchend',
        (event) => {
          event.preventDefault();
          handledByTouch = true;
          scroll();
        },
        { passive: false }
      );
    });

    scrollTarget.addEventListener('scroll', updateScrollButtons, { passive: true });
    window.addEventListener('resize', updateScrollButtons);
    window.addEventListener('load', updateScrollButtons);

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(updateScrollButtons);
      resizeObserver.observe(scrollTarget);
      const inner = scrollTarget.firstElementChild;
      if (inner) resizeObserver.observe(inner);
    }

    scrollTarget.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', updateScrollButtons, { once: true });
    });

    updateScrollButtons();
    requestAnimationFrame(updateScrollButtons);
  });
}

document.addEventListener('DOMContentLoaded', () => initCarouselNav());
document.addEventListener('shopify:section:load', (event) => initCarouselNav(event.target));
